
export default class DateConstants
{
  static dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
  static funnelDateConstantFormat = `YYYY-MM-DD`;
  static dateTimeUserFormat = 'DD.MM.YYYY HH:mm:ss';
  static clientServicesFormat = 'DD.MM.YYYY';
  static clientServicesFormatShort = 'MM.YYYY';
}